import React from 'react';

const Dashboard=()=> {
    return (
        <div>
            <h1>Hi i am dashboard</h1>
        </div>
    );
}

export default Dashboard;